import type { HomeSectionId } from "../content/siteContent";

export type SectionEntryPhase = "enter" | "hold" | "browse" | "exit";

export type SectionEntryConfig = {
  deadZone: number;
  enterRatio: number;
  holdDurationMs: number;
  initialStateIndex: number;
  velocityThreshold: number;
};

export const sectionEntryConfigs: Partial<Record<HomeSectionId, SectionEntryConfig>> = {
  projects: {
    deadZone: 0.12,
    enterRatio: 0.42,
    holdDurationMs: 380,
    initialStateIndex: 0,
    velocityThreshold: 0.18
  },
  team: {
    deadZone: 0.16,
    enterRatio: 0.48,
    holdDurationMs: 440,
    initialStateIndex: 0,
    velocityThreshold: 0.18
  },
  about: {
    deadZone: 0.1,
    enterRatio: 0.44,
    holdDurationMs: 320,
    initialStateIndex: 0,
    velocityThreshold: 0.16
  },
  contact: {
    deadZone: 0.08,
    enterRatio: 0.42,
    holdDurationMs: 280,
    initialStateIndex: 0,
    velocityThreshold: 0.14
  }
};

export function clamp01(value: number) {
  return Math.min(Math.max(value, 0), 1);
}
